import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PublicPageSF from '../../templates/PublicPageSF'
import ButtonLinkUI from '../../widgets/action/ButtonLinkUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'

const InviteDeclinePageUI = ({context, messageList, newUser, email, accountName, errorList}) =>
  <PublicPageSF context={context} className='pg_inv_dec' centered={!messageList || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_invitation_declined'>
    {
      !messageList &&
      <SpinnerComponentUI />
    }
    {
      messageList && (errorList && errorList.length > 0) &&
      <div className='g_text_center'>
        {errorList[0].message}
        <div className='g_m_top_100'>
          <ButtonLinkUI to='/' messageList={messageList} labelKey='c_continue' transparent={true} />
        </div>
      </div>
    }
    {
      messageList && !(errorList && errorList.length > 0) &&
      <React.Fragment>
        <PageTitleUI context={context} messageList={messageList} titleMessageKey='c_invitation_declined' />
        <CardUI>
          <MessageUI messageList={messageList} messageKey={
            newUser ? 'c_acct_inv_dcln_signup' : context.session.userId ? 'c_acct_inv_dcln_goacc' : 'c_acct_inv_dcln_signin'
            } args={[accountName, email]} />
          <div className='g_text_right g_m_top_100'>
            <ButtonLinkUI messageList={messageList} labelKey='c_continue' to='/' />
          </div>
        </CardUI>
      </React.Fragment>
    }
  </PublicPageSF>

export default InviteDeclinePageUI
